<template>
  <v-app>
    <v-container grid-list-md text-xs-center>
      <v-layout align-center justify-center row wrap>
        <v-flex xs12 class="mt-3">
          <img src="../../../static/img/cmg_logo.png" alt="Chip Mong Industries" height="96">
        </v-flex>
        <v-flex xs12 class="mt-3">
          <h1 class="title">Welcome to eApproval</h1>
          <span
            class="subheader"
          >Please click the link below on your iOS device to download and install the app.</span>
        </v-flex>
        <v-flex xs12 class="mt-1">
          <a
            @click="changeColor()"
            class="body-2"
            :style="{display: show ? '' : 'none'}"
            href="itms-services://?action=download-manifest&url=https://eapproval.chipmong.com/ios/cmg.plist"
          >DOWNLOAD</a>
          <p
            class="body-2"
            :style="{display: show ? 'none' : ''}"
          >Thank you. Now you can check your mobile homescreen to see the app.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'MobileApp',
  data() {
    return {
      show: true
    }
  },
  methods: {
    changeColor() {
      this.show = !this.show
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile-app/index.vue